import { render } from "./SafetyPrecautions.vue?vue&type=template&id=c8bbb7ca&scoped=true"
import script from "./SafetyPrecautions.vue?vue&type=script&lang=js"
export * from "./SafetyPrecautions.vue?vue&type=script&lang=js"

import "./SafetyPrecautions.vue?vue&type=style&index=0&id=c8bbb7ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8bbb7ca"]])

export default __exports__